<template>
    <LayoutPage
        imageName="map-bg.jpg"
        :title="'Potrebujete poradiť?'">
        <template v-slot:banner>
            <BannerSmallerWithSearchAndButton
                :imageName="$t('UI.banners.smallerBannerImage')"
                :title="title"
                :description="description"
            />
        </template>
        <template v-slot:content>
            <section class="mm-section mm-section__faq">
                <div class="mm-section-content">
                    <div class="mm-section__faq-search">
                        <div class="mm-section__row mm-section__row--space-bottom-l">
                            <slot name="searchbox"></slot>
                        </div>
                        <div class="mm-section__row">
                            <div class="mm-section__faq-help">
                                <slot name="content"></slot>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
    </LayoutPage>
</template>

<script>
import LayoutPage from '@/components/layouts/Page';
import BannerSmallerWithSearchAndButton from '@/components/ui/Banner/SmallerWithSearchAndButton';

export default {
    components: {
        LayoutPage,
        BannerSmallerWithSearchAndButton
    },
    props: {
        title: {
            type: String
        },
        description: {
            type: String
        }
    },
    data() {
        return {
            publicPath: process.env.BASE_URL
        };
    }
}
</script>